import { render } from "./RankingTable.vue?vue&type=template&id=510eefcb"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"

import "./RankingTable.vue?vue&type=style&index=0&id=510eefcb&lang=scss"

import exportComponent from "/codebuild/output/src2796879663/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__